(function () {
	function swiperInit() {
		if (typeof subSliderInit === 'function') subSliderInit(true);
		if (typeof sliderInit === 'function') sliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
		$('.js-media-list').each(function () {
			if (this.swiper && typeof this.swiper.destroy === 'function') {
				this.swiper.destroy();
			}
		});
		$('.js-media-sublist').each(function () {
			if (this.swiper && typeof this.swiper.destroy === 'function') {
				this.swiper.destroy();
			}
		});

		swiperInit();
	});

	swiperInit();
})();
